import HBMenuItem from './HBMenuItem';
import { HBMenuListProps } from './HBMenu.types';
import React, { memo } from 'react';
import { ArrowRight16 } from '@honeybook/icons';
import { Sub } from '@radix-ui/react-dropdown-menu';
import {
    StyledDivider,
    StyledSectionTitle,
    StyledSubContent
} from './HBMenu.styles';

const HBMenuList = memo(function HBMenuList({
    menuItems,
    size,
    subMenuSize,
    hideArrowIconInSubmenu,
    isListItemContentFullWidth
}: HBMenuListProps) {
    return (
        <>
            {menuItems.map((item, index) => {
                switch (item.type) {
                    case 'divider':
                        return (
                            <StyledDivider key={index} $margin={item.margin} />
                        );
                    case 'section': {
                        const { sectionTitle, ...restItem } = item;
                        return (
                            <HBMenuItem
                                key={index}
                                size={size}
                                item={{
                                    ...restItem,
                                    type: 'item',
                                    title: (
                                        <StyledSectionTitle>
                                            {sectionTitle}
                                        </StyledSectionTitle>
                                    )
                                }}
                                dropdownReferenceType="section"
                                isListItemContentFullWidth={
                                    isListItemContentFullWidth
                                }
                            />
                        );
                    }
                    case 'submenu':
                        return (
                            <Sub key={index}>
                                <HBMenuItem
                                    item={{
                                        ...item,
                                        type: 'item',
                                        rightIcon: !hideArrowIconInSubmenu && (
                                            <ArrowRight16 />
                                        )
                                    }}
                                    size={size}
                                    dropdownReferenceType="subTrigger"
                                    isListItemContentFullWidth={
                                        isListItemContentFullWidth
                                    }
                                />
                                <StyledSubContent $maxHeight={item.maxHeight}>
                                    <HBMenuList
                                        menuItems={item.menuItems}
                                        size={subMenuSize || size}
                                        isListItemContentFullWidth={
                                            isListItemContentFullWidth
                                        }
                                    />
                                </StyledSubContent>
                            </Sub>
                        );
                    default:
                        return (
                            <HBMenuItem
                                item={item}
                                size={size}
                                key={index}
                                isListItemContentFullWidth={
                                    isListItemContentFullWidth
                                }
                            />
                        );
                }
            })}
        </>
    );
});

export default HBMenuList;
